<template>
  <div class="long-arrow-right" />
</template>

<script>
export default {
  name: 'ArrowIcon'
}
</script>
<style lang="scss" scoped>
.long-arrow-right {
  width: 6px;
  height: 6px;
  border-top: 1px solid #1370FF;
  border-left: 1px solid #1370FF;
  display: inline-block;
  transform: rotate(135deg);

  &:after {
    content: "";
    display: block;
    width: 1px;
    height: 12px;
    background-color: #1370FF;
    transform: rotate(-45deg) translate(4px, 2px);
    left: 0;
    top: 0;
  }
}
</style>
